import { getDate } from "date-fns";
import React from "react";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import './OrderSummary.css'
import { fixDateDirection } from "../../utils/orderUtils";
import { isGenericEventProduct, isGenericOnlyLp, participantsSummary } from "../../utils/audienceUtils";
function OrderSummary(props) {
    const orderCart = useSelector(state => state.reducer);
    // Adult-only wording when the selected product is a generic event OR the
    // whole LP is generic-only (date flow step one - nothing selected yet).
    const genericEvent = isGenericEventProduct(orderCart.selectedActivity) || isGenericOnlyLp(orderCart.products);

    return <>
    {isMobile ? <div className="orderSummary">
                    <div className="gap-2 px-2 d-flex justify-content-start text-mahuti">
                        <span>{orderCart?.selectedActivity?.Title || '--'}</span>
                        <span>{orderCart?.activityDate}</span>
                    </div>
                    <div className="d-flex align-items-center px-2">
                        <div className="col d-flex justify-content-start text-mahuti">
                            {/* <span>ילד {orderCart?.visitors?.underAge || '--'} x</span>
                            <span>מבוגרי* {orderCart?.visitors?.adults || '--'}</span> */}
                            <span>{participantsSummary(orderCart.visitors, genericEvent)}</span>
                        </div>
                        <div className="col d-flex justify-content-end orderPayment" tabIndex="0">
                        לתשלום: {props.orderPayment}₪
                        </div>
                    </div>
                </div> :
                <div className="orderSummary card border-0 px-3 py-2 z-index-2 rounded-0">
                    <div className="card-body container">
                        <div className="row ">
                            <h2 tabIndex="0" className="col p-1 d-flex text-start card-title">סיכום רכישה</h2>
                        </div>
                        <ul className="row border-bottom py-2 px-0">

                            {orderCart.selectedActivity && (
                                <li className="d-flex justify-content-between align-items-center mb-3 px-0">
                                    <div className="col p-1 d-flex text-start header-detail">שם פעילות</div>
                                    <div className="col p-1 d-flex justify-content-end text-mahuti">{orderCart.selectedActivity?.Title || '--'}</div>
                                </li>
                            )}

                            {(orderCart.visitors?.adults || orderCart.visitors?.underAge) ? (
                                <li className="d-flex justify-content-between align-items-center mb-3 px-0">
                                    <div className="col-5 p-1 d-flex text-start header-detail">כמות משתתפים</div>
                                    <div className="col-7 p-1 d-flex justify-content-end text-mahuti">
                                        {participantsSummary(orderCart.visitors, genericEvent)}
                                    </div>
                                </li>)
                                : <></>
                            }


                            {orderCart.activityDate && (
                                <li className="d-flex justify-content-between align-items-center mb-3 px-0">
                                    <div className="col p-1 d-flex text-start header-detail">תאריך הפעילות</div>
                                    <div className="col p-1 d-flex justify-content-end text-mahuti">{fixDateDirection(String(orderCart.activityDate))}</div>
                                </li>
                            )}

                            {orderCart.selectedActivity?.timing && (
                                <li className="d-flex justify-content-between align-items-center mb-3 px-0">
                                    <div className="col p-1 d-flex text-start header-detail">שעת הפעילות:</div>
                                    <div className="col p-1 d-flex justify-content-end text-mahuti">
                                        <span aria-label={`${orderCart.selectedActivity?.timing?.startTime} עד ${orderCart.selectedActivity?.timing?.endTime}`}>
                                            {orderCart.selectedActivity?.timing?.endTime} - {orderCart.selectedActivity?.timing?.startTime}
                                        </span>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>
                    <div className="card-footer bg-body border-0 d-flex justify-content-end header-detail">
                        <p className="almoni_tzar_bold">
                            סך הכל לתשלום: {props.orderPayment}₪
                        </p>
                    </div>
                </div>}
        
        
    </>


}


export default OrderSummary;